import { appConfig } from '../config'

export function useSlack() {
  return {
    async sendMessage(text: string) {
      if (process.env.NODE_ENV === 'development') {
        console.info(text)
        return
      }
      await fetch('https://slack-message.now.sh', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          channel: appConfig.slackNotifyChannel,
          text,
        }),
        mode: 'cors',
      })
    },
  }
}
